var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeatureIcon22({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.4942 34.2707V4.92285H34.3589V34.2707H5.63524V4.92285H1.5V38.5003H38.5V34.2716L38.4942 34.2707Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.794 1.5H1.5V6.125H19.075V1.5H14.794Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0992 1.5H19.0742V6.125H31.0992V1.5Z",
    fill: "#2650FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8008 1.5H30.1758V6.125H34.8008V1.5Z",
    fill: "#2650FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M38.479 1.5H34.3438V5.63037H38.479V1.5Z",
    fill: "#FFBB07"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.3246 6.72574L33.2457 3.80469L36.1667 6.72574L33.2457 9.64679L30.3246 6.72574ZM27.5078 15.3784L30.276 12.6101L30.2774 12.6115L33.1984 9.69044L30.2774 6.76938L27.5091 9.53761L27.5078 9.53625L24.5867 12.4573L27.5078 15.3784ZM21.6193 15.4211L24.5404 12.5L27.4614 15.4211L24.5404 18.3422L21.6193 15.4211ZM21.5721 15.4638L18.651 18.3849L21.5721 21.3059L24.4931 18.3849L21.5721 15.4638ZM15.6836 21.3487L18.6046 18.4276L21.5257 21.3487L18.6046 24.2697L15.6836 21.3487Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M38.479 5.45703H34.3438V9.5874H38.479V5.45703Z",
    fill: "#FFBB07"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M38.479 9.40332H34.3438V13.5376H38.479V9.40332Z",
    fill: "#FFBB07"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatureIcon22);
export default __webpack_public_path__ + "static/media/feature_icon_2_2.41be73197359b9909dd9411f639e08ed.svg";
export { ForwardRef as ReactComponent };